module.exports = __webpack_public_path__ + "img/jiuzhang-back-third@2x.9eeedccd.png";